module.exports = __webpack_public_path__ + "static/img/loading-white.a2e29fe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/loading-white.gif
// module id = GloD
// module chunks = 1